import { get, patch, post, put } from './client';
import type { ApiResult } from './types';

export interface CompanyCategory {
    category_id: number;
    label: string;
    type: 'SERVICE';
    url_identifier: string;
    rank: number | null;
    count: number;
    is_enabled: boolean;
}

export interface CompanyCategoryInput {
    label: string;
    url_identifier?: string;
    rank?: number | null;
}

const BASE_URL = '/admin/company-categories';

export function getCompanyCategories(): Promise<ApiResult<CompanyCategory[]>> {
    return get<CompanyCategory[]>(BASE_URL);
}

export function addCompanyCategory(
    data: CompanyCategoryInput
): Promise<ApiResult<CompanyCategory>> {
    return post<CompanyCategory>(BASE_URL, data);
}

export function updateCompanyCategory(
    categoryId: number,
    data: CompanyCategoryInput
): Promise<ApiResult<CompanyCategory>> {
    return put<CompanyCategory>(`${BASE_URL}/${categoryId}`, data);
}

export function setCompanyCategoryStatus(
    categoryId: number,
    isEnabled: boolean
): Promise<ApiResult<CompanyCategory>> {
    return patch<CompanyCategory>(`${BASE_URL}/${categoryId}/status`, {
        is_enabled: isEnabled
    });
}
